import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import FormikActions from "../../../../../../commons/formik/FormikActions";
import FormikTextField from "../../../../../../commons/formik/FormikTextField";
import { StyledResolucion } from "../../../../../../styled/Prevencion";
import { ValidateMetodologiaEmpleada } from "../../formValidations";

const MetodologiaForm = ({ open, values, handleSubmit, handleClose, metodologiasEmpleadas }) => {
    return (
        <Dialog open={open} fullWidth maxWidth="sm" >
            <DialogTitle>Metodología</DialogTitle>
            <Formik
                initialValues={values}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
                validationSchema={ValidateMetodologiaEmpleada(metodologiasEmpleadas)}
            >
                {({ values, setFieldValue }) => (

                    <Form>
                        <DialogContent>
                            <Grid container  >
                                <StyledResolucion.DialogGridItem item xs={12} >
                                    <FormikTextField
                                        name="nombreTiposEstudio"
                                        label="Tipo de Estudio*"
                                        fullWidth
                                        disabled
                                    />
                                </StyledResolucion.DialogGridItem>


                                <StyledResolucion.DialogGridItem item xs={12} >
                                    <FormikTextField
                                        name="descripcion"
                                        label="Metodología Empleada *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>


                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <FormikActions handleCancel={handleClose} />
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    )
}


export default MetodologiaForm;